module.exports = __webpack_public_path__ + "static/img/2.b16d306.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/internetimg/2.png
// module id = 1icg
// module chunks = 9